import React, { Component } from "react";
import "../App.css";
import AnxietyBanner from "../images/Reduce Anxiety/anxiety-banner.png";
import CloseArrow from "../images/close_arrow.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class AleviateAnxiety extends Component {
  state = {
    bookList: [
      {
        id: 1,
        title: "Unf*ck Your Anxiety",
        author: "Faith Harper",
        preview:
          "Anxiety is a survival skill gone haywire. It happens when our brain is working so hard to protect us that it forgets to notice that the danger has passed. It feels like choking, stifling, smothering, tingling, panicking--our brains cut out and we start to make bad decisions--all normal anxiety reactions. Dr. Faith G. Harper, author of the bestselling Unfuck Your Brain and This is Your Brain on Depression packs a ton of knowledge and help into this practical manual. She helps us understand the history and science of anxiety, realize when it's become a serious problem, know the difference between anxiety and other conditions, and cope with it in the moment as well as addressing it long term.",
      },
      {
        id: 2,
        title: "Chatter",
        author: "Ethan Kross",
        preview:
          "An award-winning psychologist reveals the hidden power of our inner voice and shows how to harness it to live a healthier, more satisfying, and more productive life.",
      },
      {
        id: 3,
        title: "Cleaning Up Your Mental Mess",
        author: "Dr. Caroline Leaf",
        preview:
          "A best-selling author and neuroscientist offers five proven steps to help you overcome the unhealthy thinking habits that contribute to anxiety, depression, and intrusive thoughts and replace them with positive thinking that leads to health, happiness, and success.",
      },
      {
        id: 4,
        title: "10% Happier",
        author: "Dan Harris",
        preview:
          "Nightline anchor Dan Harris embarks on an unexpected, hilarious, and deeply skeptical odyssey through the strange worlds of spirituality and self-help, and discovers a way to get happier that is truly achievable. 10% Happier takes listeners on a ride from the outer reaches of neuroscience to the inner sanctum of network news to the bizarre fringes of America's spiritual scene, and leaves them with a takeaway that could actually change their lives.",
      },
      {
        id: 5,
        title: "The Stress-Proof Brain",
        author: "Melanie Greenberg PhD",
        preview:
          "Modern times are stressful - and it's killing us. Unfortunately, we can't avoid the things that stress us out, but we can change how we respond to them. In this breakthrough book, a clinical psychologist and neuroscience expert offers an original approach to help listeners harness the power of positive emotions and overcome stress for good.",
      },
      {
        id: 6,
        title:
          "Resilient: How to Grow an Unshakable Core of Calm, Strength, and Happiness",
        author: "Rick Hanson",
        preview:
          "True resilience is much more than enduring terrible conditions. We need resilience every day to raise a family, work at a job, cope with stress, deal with health problems, navigate issues with others, heal from old pain, and simply keep on going. This practical guide is full of concrete suggestions, experiential practices, personal examples, and insights into the brain. It includes effective ways to interact with others and to repair and deepen important relationships.",
      },
      {
        id: 7,
        title: "Get Out of Your Head",
        author: "Jennie Allen",
        preview:
          "In Get Out of Your Head, Jennie inspires and equips us to transform our emotions, our outlook, and even our circumstances by taking control of our thoughts. Our enemy is determined to get in our heads to make us feel helpless, overwhelmed, and incapable of making a difference for the kingdom of God. But when we submit our minds to Christ, the promises and goodness of God flood our lives in remarkable ways. It starts in your head. And from there, the possibilities are endless.",
      },
      {
        id: 8,
        title: "The Healthy Mind Toolkit",
        author: "Alice Boyes PhD",
        preview:
          "In The Healthy Mind Toolkit, Dr. Alice Boyes provides easy, practical solutions that will help you identify how you’re holding yourself back and how to reverse your self-sabotaging behaviors. Blending scientific research with techniques from cognitive behavioral therapy, this engaging book will take you through the steps to address this overarching problem.",
      },
    ],
  };

  handleBook1Click = () => {
    document
      .getElementById("bump-out-1")
      .classList.toggle("bump-out-slide-right");
  };

  handleBook2Click = () => {
    document
      .getElementById("bump-out-2")
      .classList.toggle("bump-out-slide-left");
  };

  handleBook3Click = () => {
    document
      .getElementById("bump-out-3")
      .classList.toggle("bump-out-slide-right");
  };

  handleBook4Click = () => {
    document
      .getElementById("bump-out-4")
      .classList.toggle("bump-out-slide-left");
  };

  handleBook5Click = () => {
    document
      .getElementById("bump-out-5")
      .classList.toggle("bump-out-slide-right");
  };

  handleBook6Click = () => {
    document
      .getElementById("bump-out-6")
      .classList.toggle("bump-out-slide-left");
  };

  handleBook7Click = () => {
    document
      .getElementById("bump-out-7")
      .classList.toggle("bump-out-slide-right");
  };

  handleBook8Click = () => {
    document
      .getElementById("bump-out-8")
      .classList.toggle("bump-out-slide-left");
  };

  render() {
    return (
      <div>
        <section className="time-banner-wrapper">
          <img
            className="Time-Banner"
            src={AnxietyBanner}
            alt="anxiety banner"
          ></img>
          <div>
            <h1>Alleviate Anxiety</h1>
            <p>
              Words that inspire can soothe a frazzled mind and comfort the
              agitated soul
            </p>
          </div>
        </section>
        <section className="time-grid-container">
          <div className="grid-title">
            <h1>Popular Titles</h1>
            <input type="search" placeholder="search titles"></input>
          </div>

          {/* Book 1 */}
          <div className="bumpout-animation-wrapper book-1-position">
            <div id="bump-out-1" className="bump-out">
              <div className="bump-out-content-wrapper">
                <h2>Title:{this.state.bookList[0].title}</h2>
                <h2>Author: {this.state.bookList[0].author}</h2>
                <h2>
                  Rating:{" "}
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                </h2>
                <h2 className="text-alignment">
                  Preview:
                  <br />
                  <br />
                  {this.state.bookList[0].preview}
                </h2>
              </div>
              <button className="find-button" href="#" target="_blank">
                Find It
              </button>
              <a href="#" className="add-to-list">
                Add to List
              </a>
              <img
                className="close-bump-out-left"
                src={CloseArrow}
                onClick={this.handleBook1Click}
              />
            </div>
            <div
              className="anxiety-book1-cover book1-style"
              onClick={this.handleBook1Click}
            ></div>
          </div>

          {/* Book 2 */}
          <div className="bumpout-animation-wrapper book-2-position">
            <div id="bump-out-2" className="bump-out">
              <div className="bump-out-content-wrapper">
                <h2>Title:{this.state.bookList[1].title}</h2>
                <h2>Author: {this.state.bookList[1].author}</h2>
                <h2>
                  Rating:{" "}
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                </h2>
                <h2 className="text-alignment">
                  Preview:
                  <br />
                  <br />
                  {this.state.bookList[1].preview}
                </h2>
              </div>
              <button className="find-button" href="#" target="_blank">
                Find It
              </button>
              <a href="#" className="add-to-list">
                Add to List
              </a>
              <img
                className="close-bump-out-right"
                src={CloseArrow}
                onClick={this.handleBook2Click}
              />
            </div>
            <div
              className="anxiety-book2-cover book2-style"
              onClick={this.handleBook2Click}
            ></div>
          </div>

          {/* Book 3 */}
          <div className="bumpout-animation-wrapper book-3-position">
            <div id="bump-out-3" className="bump-out">
              <div className="bump-out-content-wrapper">
                <h2>Title:{this.state.bookList[2].title}</h2>
                <h2>Author: {this.state.bookList[2].author}</h2>
                <h2>
                  Rating:{" "}
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                </h2>
                <h2 className="text-alignment">
                  Preview:
                  <br />
                  <br />
                  {this.state.bookList[2].preview}
                </h2>
              </div>
              <button className="find-button" href="#" target="_blank">
                Find It
              </button>
              <a href="#" className="add-to-list">
                Add to List
              </a>
              <img
                className="close-bump-out-left"
                src={CloseArrow}
                onClick={this.handleBook3Click}
              />
            </div>
            <div
              className="anxiety-book3-cover book3-style"
              onClick={this.handleBook3Click}
            ></div>
          </div>

          {/* Book 4 */}
          <div className="bumpout-animation-wrapper book-4-position">
            <div id="bump-out-4" className="bump-out">
              <div className="bump-out-content-wrapper">
                <h2>Title:{this.state.bookList[3].title}</h2>
                <h2>Author: {this.state.bookList[3].author}</h2>
                <h2>
                  Rating:{" "}
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                </h2>
                <h2 className="text-alignment">
                  Preview:
                  <br />
                  <br />
                  {this.state.bookList[3].preview}
                </h2>
              </div>
              <button className="find-button" href="#" target="_blank">
                Find It
              </button>
              <a href="#" className="add-to-list">
                Add to List
              </a>
              <img
                className="close-bump-out-right"
                src={CloseArrow}
                onClick={this.handleBook4Click}
              />
            </div>
            <div
              className="anxiety-book4-cover book4-style"
              onClick={this.handleBook4Click}
            ></div>
          </div>

          {/* Book 5 */}
          <div className="bumpout-animation-wrapper book-5-position">
            <div id="bump-out-5" className="bump-out">
              <div className="bump-out-content-wrapper">
                <h2>Title:{this.state.bookList[4].title}</h2>
                <h2>Author: {this.state.bookList[4].author}</h2>
                <h2>
                  Rating:{" "}
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                </h2>
                <h2 className="text-alignment">
                  Preview:
                  <br />
                  <br />
                  {this.state.bookList[4].preview}
                </h2>
              </div>
              <button className="find-button" href="#" target="_blank">
                Find It
              </button>
              <a href="#" className="add-to-list">
                Add to List
              </a>
              <img
                className="close-bump-out-left"
                src={CloseArrow}
                onClick={this.handleBook3Click}
              />
            </div>
            <div
              className="anxiety-book5-cover book5-style"
              onClick={this.handleBook5Click}
            ></div>
          </div>

          {/* Book 6 */}
          <div className="bumpout-animation-wrapper book-6-position">
            <div id="bump-out-6" className="bump-out">
              <div className="bump-out-content-wrapper">
                <h2>Title:{this.state.bookList[5].title}</h2>
                <h2>Author: {this.state.bookList[5].author}</h2>
                <h2>
                  Rating:{" "}
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                </h2>
                <h2 className="text-alignment">
                  Preview:
                  <br />
                  <br />
                  {this.state.bookList[5].preview}
                </h2>
              </div>
              <button className="find-button" href="#" target="_blank">
                Find It
              </button>
              <a href="#" className="add-to-list">
                Add to List
              </a>
              <img
                className="close-bump-out-right"
                src={CloseArrow}
                onClick={this.handleBook4Click}
              />
            </div>
            <div
              className="anxiety-book6-cover book6-style"
              onClick={this.handleBook6Click}
            ></div>
          </div>

          {/* Book 7 */}
          <div className="bumpout-animation-wrapper book-7-position">
            <div id="bump-out-7" className="bump-out">
              <div className="bump-out-content-wrapper">
                <h2>Title:{this.state.bookList[6].title}</h2>
                <h2>Author: {this.state.bookList[6].author}</h2>
                <h2>
                  Rating:{" "}
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                </h2>
                <h2 className="text-alignment">
                  Preview:
                  <br />
                  <br />
                  {this.state.bookList[6].preview}
                </h2>
              </div>
              <button className="find-button" href="#" target="_blank">
                Find It
              </button>
              <a href="#" className="add-to-list">
                Add to List
              </a>
              <img
                className="close-bump-out-left"
                src={CloseArrow}
                onClick={this.handleBook7Click}
              />
            </div>
            <div
              className="anxiety-book7-cover book7-style"
              onClick={this.handleBook7Click}
            ></div>
          </div>

          {/* Book 8 */}
          <div className="bumpout-animation-wrapper book-8-position">
            <div id="bump-out-8" className="bump-out">
              <div className="bump-out-content-wrapper">
                <h2>Title:{this.state.bookList[7].title}</h2>
                <h2>Author: {this.state.bookList[7].author}</h2>
                <h2>
                  Rating:{" "}
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                </h2>
                <h2 className="text-alignment">
                  Preview:
                  <br />
                  <br />
                  {this.state.bookList[7].preview}
                </h2>
              </div>
              <button className="find-button" href="#" target="_blank">
                Find It
              </button>
              <a href="#" className="add-to-list">
                Add to List
              </a>
              <img
                className="close-bump-out-right"
                src={CloseArrow}
                onClick={this.handleBook8Click}
              />
            </div>
            <div
              className="anxiety-book8-cover book8-style"
              onClick={this.handleBook8Click}
            ></div>
          </div>
        </section>
      </div>
    );
  }
}

export default AleviateAnxiety;
